"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMask = exports.prepareMaskObjects = exports.addOutlineLayer = exports.addClipGroup = void 0;
var _paper = _interopRequireDefault(require("paper"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _Logger = _interopRequireDefault(require("../../../Utils/Logger"));
var _SVGfix = require("./SVGfix");
var _DOM = require("../../../Utils/DOM");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var logger = new _Logger["default"]('UseMask');
var loadMask = function loadMask(src) {
  return new Promise(function (resolve, reject) {
    _paper["default"].project.importSVG(src, {
      insert: false,
      onLoad: function onLoad(group) {
        if (!group) {
          throw new Error("Error while parsing SVG data! Please check the following file: ".concat(src));
        }
        group.boundsOrig = group.bounds.clone();
        // remove clipping rect from imported svg (paperjs svg viewBox implementation)
        if (group.isClipped()) {
          group.setClipped(false);
          group.firstChild.remove(); // the clip mask is always the first child
        }

        resolve(group);
      },
      onError: function onError(e) {
        logger.error('Error occurred while loading the mask: ' + src);
        reject(e);
      }
    });
  });
};
var loadMaskSource = function loadMaskSource(src) {
  return new Promise(function (resolve, reject) {
    _paper["default"].project.importSVG(src, {
      insert: false,
      onLoad: function onLoad(items, svgData) {
        resolve((0, _SVGfix.fixSvgData)(svgData));
      },
      onError: reject
    });
  });
};
var addClipGroup = exports.addClipGroup = function addClipGroup(project, maskItem) {
  var clipItem = maskItem.clone();
  clipItem.name = 'clipGroup';
  project.layers.designerLayer.insertChild(0, clipItem);
  project.layers.designerLayer.clipped = true;
};
var traverseItems = function traverseItems(item, cb) {
  if (false === cb(item)) {
    return;
  }
  if (item.children) {
    var children = _toConsumableArray(item.children);
    var _iterator = _createForOfIteratorHelper(children),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        traverseItems(child, cb);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};
var prepareMaskObjects = exports.prepareMaskObjects = function prepareMaskObjects(maskItem) {
  var paths = [];
  traverseItems(maskItem, function (item) {
    if (item instanceof _paper["default"].Path || item instanceof _paper["default"].CompoundPath) {
      paths.push(item);
      return false;
    } else if (item.toPath) {
      paths.push(item.toPath(false));
    }
  });
  if (!paths.length) {
    return;
  }
  var closedPaths = paths.filter(function (path) {
    return path.isClosed();
  });
  var openedPaths = paths.filter(function (path) {
    return !path.isClosed();
  });
  var unitedClosedPaths = closedPaths[0];
  for (var i = 1; closedPaths[i]; i++) {
    unitedClosedPaths = unitedClosedPaths.unite(closedPaths[i]);
  }
  var unitedOpenedPaths = openedPaths[0];
  for (var _i = 1; openedPaths[_i]; _i++) {
    unitedOpenedPaths = unitedOpenedPaths.unite(openedPaths[_i]);
  }
  maskItem.removeChildren();
  unitedClosedPaths && maskItem.addChild(unitedClosedPaths);
  unitedOpenedPaths && maskItem.addChild(unitedOpenedPaths);
};
var addOutlineLayer = exports.addOutlineLayer = function addOutlineLayer(project, maskItem, options) {
  var _options$outlineColor = options.outlineColor,
    outlineColor = _options$outlineColor === void 0 ? 'black' : _options$outlineColor,
    _options$scaling = options.scaling,
    scaling = _options$scaling === void 0 ? 1 : _options$scaling,
    _options$outlineSize = options.outlineSize,
    outlineSize = _options$outlineSize === void 0 ? 2 : _options$outlineSize;
  var _outlineSize = outlineSize / (scaling || 1);
  var outlineItem = maskItem.clone();
  outlineItem.fillColor = 'transparent';
  outlineItem.strokeColor = outlineColor;
  outlineItem.strokeWidth = _outlineSize;

  // adds a layer for the outline
  var layer = new _paper["default"].Layer({
    name: 'outlineLayer',
    children: [outlineItem],
    locked: true
  });
  project.addLayer(layer);
  return layer;
};
var loadMaskSVG = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(svg) {
    var blob, url;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          blob = new Blob([svg], {
            type: 'image/svg+xml'
          });
          url = URL.createObjectURL(blob);
          _context.prev = 2;
          _context.next = 5;
          return loadMask(url);
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.prev = 6;
          URL.revokeObjectURL(url);
          return _context.finish(6);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2,, 6, 9]]);
  }));
  return function loadMaskSVG(_x) {
    return _ref.apply(this, arguments);
  };
}();
var useMask = exports.useMask = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(project, initialMaskData) {
    var scaling, _maskData, _maskDataSVG, maskHandler, currentLayer, dispose, updateOutline, init, outlineLayer, toggleOutline, fixSVGExport;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _maskData = {};
          maskHandler = {}; // the layer that holds all the user items
          currentLayer = project.activeLayer;
          currentLayer.name = 'designerLayer';
          dispose = function dispose() {
            var _project$layers = project.layers,
              outlineLayer = _project$layers.outlineLayer,
              designerLayer = _project$layers.designerLayer;
            outlineLayer && outlineLayer.remove();
            if (designerLayer && designerLayer.isClipped()) {
              designerLayer.children.clipGroup.remove();
              designerLayer.setClipped(false);
            }
            _maskData = {};
          };
          updateOutline = function updateOutline() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var outlineLayer = project.layers.outlineLayer;
            if (!outlineLayer) {
              return;
            }
            var _maskData2 = _maskData,
              _maskData2$outlineSiz = _maskData2.outlineSize,
              outlineSize = _maskData2$outlineSiz === void 0 ? 2 : _maskData2$outlineSiz;
            var getZoomFactor = options.getZoomFactor;
            var zoomFactor = getZoomFactor ? getZoomFactor({
              zoom: currentLayer.view.zoom
            }) : currentLayer.view.zoom;
            var strokeWidth = outlineSize / zoomFactor;
            outlineLayer.getItems({
              recursive: true,
              match: function match(item) {
                return item.strokeWidth;
              }
            }).forEach(function (item) {
              item.strokeWidth = strokeWidth;
            });
          };
          init = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(function () {
              var maskData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                var _project$layers2, designerLayer, outlineLayer, src, _maskData$outlineColo, outlineColor, _maskData$x, x, _maskData$y, y, _maskData$rotation, rotation, mask, _maskData$relativeSca, relativeScaling, position;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _project$layers2 = project.layers, designerLayer = _project$layers2.designerLayer, outlineLayer = _project$layers2.outlineLayer;
                      if (!(0, _isEqual["default"])(maskData, _maskData)) {
                        _context2.next = 4;
                        break;
                      }
                      if (!(designerLayer.isClipped() && outlineLayer)) {
                        _context2.next = 4;
                        break;
                      }
                      return _context2.abrupt("return");
                    case 4:
                      src = maskData.src, _maskData$outlineColo = maskData.outlineColor, outlineColor = _maskData$outlineColo === void 0 ? 'black' : _maskData$outlineColo, _maskData$x = maskData.x, x = _maskData$x === void 0 ? 0.5 : _maskData$x, _maskData$y = maskData.y, y = _maskData$y === void 0 ? 0.5 : _maskData$y, _maskData$rotation = maskData.rotation, rotation = _maskData$rotation === void 0 ? 0 : _maskData$rotation;
                      _context2.next = 7;
                      return loadMaskSource(src);
                    case 7:
                      _maskDataSVG = _context2.sent;
                      _context2.next = 10;
                      return loadMaskSVG(_maskDataSVG);
                    case 10:
                      mask = _context2.sent;
                      _maskData$relativeSca = maskData.relativeScaling, relativeScaling = _maskData$relativeSca === void 0 ? false : _maskData$relativeSca;
                      scaling = relativeScaling ? relativeScaling / (mask.boundsOrig.width / currentLayer.view.size.width) : maskData.scaling || 1;
                      position = currentLayer.view.size.multiply(new _paper["default"].Point(x, y));
                      dispose();
                      _maskData = maskData;
                      prepareMaskObjects(mask);
                      mask.position = mask.position.add(position).subtract(mask.boundsOrig.center);
                      mask.rotation = rotation / Math.PI * 180;
                      mask.scale(scaling);
                      mask.locked = true;
                      addClipGroup(project, mask);
                      addOutlineLayer(project, mask, {
                        scaling: scaling,
                        outlineColor: outlineColor
                      });
                      updateOutline();

                      // after all layers added, the first layer should be activated again
                      currentLayer.activate();
                    case 25:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              })();
            });
            return function init() {
              return _ref3.apply(this, arguments);
            };
          }();
          toggleOutline = function toggleOutline(visible) {
            var updateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            outlineLayer = project.layers.outlineLayer || outlineLayer;
            if (outlineLayer) {
              var originalValue = outlineLayer.visible;
              if (!visible) {
                // remove in case of not visible in order to exclude from svg export
                outlineLayer.remove();
              } else if (!outlineLayer.visible) {
                // add it again if it is not visible
                project.addLayer(outlineLayer);
              }
              outlineLayer.visible = visible;
              updateOptions && updateOutline(updateOptions);
              project.view.update();
              // return the restore function
              return function () {
                return maskHandler.toggleOutline(originalValue, updateOptions);
              };
            }
            return function () {};
          };
          fixSVGExport = function fixSVGExport(svgDocOrStr) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var xmlDoc = typeof svgDocOrStr === 'string' ? new DOMParser().parseFromString(svgDocOrStr, 'text/xml') : svgDocOrStr;
            var clipGroup = xmlDoc.getElementById('clipGroup');
            clipGroup && (0, _DOM.unwrap)(clipGroup); // remove <g> element from clip path

            var _options$asString = options.asString,
              asString = _options$asString === void 0 ? false : _options$asString;
            return asString ? new XMLSerializer().serializeToString(xmlDoc) : xmlDoc;
          }; // initialize automatically
          dispose(); // remove the current mask in every case
          if (!initialMaskData) {
            _context3.next = 13;
            break;
          }
          _context3.next = 13;
          return init(initialMaskData);
        case 13:
          Object.assign(maskHandler, {
            init: init,
            toggleOutline: toggleOutline,
            updateOutline: updateOutline,
            fixSVGExport: fixSVGExport,
            dispose: dispose
          });
          return _context3.abrupt("return", maskHandler);
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function useMask(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();